/***Validate uploaded voucher list *******************************************/
export const ValidateVoucherWriteOff = async (jsonBody) => {
    try {
        const ApiURL = window.Links.ApiURL;
        const authToken = localStorage.getItem("authToken");

        const requestOptions = {
            method: "POST",
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${authToken}`
            },
            body: JSON.stringify(jsonBody)
        };

        const response = await fetch(`${ApiURL}VoucherWrteOff/ValidateVoucherWriteOff`, requestOptions);
        const result = await response.json();

        if (!result.success) {
            return { success: false, data: [], message: result.message };
        }

        return { success: true, vlist: result.vlist, elist: result.elist, message: result.message };
    } catch (error) {
        console.error("ValidateVoucherWriteOff error:", error);
        return { success: false, data: [] };
        //throw error; // Rethrow the error to be handled by the caller
    }
};
/**************************************************************************************/


/***Validate uploaded voucher list *******************************************/
export const ValidateSingleVoucherWriteOff = async (jsonBody) => {
    try {
        const ApiURL = window.Links.ApiURL;
        const authToken = localStorage.getItem("authToken");

        const requestOptions = {
            method: "POST",
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${authToken}`
            },
            body: JSON.stringify(jsonBody)
        };

        const response = await fetch(`${ApiURL}VoucherWrteOff/ValidateSingleVoucher`, requestOptions);
        const result = await response.json();

        if (!result.success) {
            return { success: false, data: [], message: result.message };
        }

        return { success: true, data: result.data, message: result.message };
    } catch (error) {
        console.error("ValidateSingleVoucherWriteOff error:", error);
        return { success: false, data: [] };
        //throw error; // Rethrow the error to be handled by the caller
    }
};
/**************************************************************************************/


/***Save/Update voucher list ******************************************/
export const SaveUpdateVoucherWriteOff = async (jsonBody) => {
    try {
        const ApiURL = window.Links.ApiURL;
        const authToken = localStorage.getItem("authToken");

        const requestOptions = {
            method: "POST",
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${authToken}`
            },
            body: JSON.stringify(jsonBody)
        };

        const response = await fetch(`${ApiURL}VoucherWrteOff/SaveVoucherWriteOff`, requestOptions);
        const result = await response.json();

        if (!result.success) {
            return { success: false, data: [], message: result.message };
        }

        return { success: true, data: result.vlist, message: result.message };
    } catch (error) {
        console.error("ValidateVoucherWriteOff error:", error);
        return { success: false, data: [] };
        //throw error; // Rethrow the error to be handled by the caller
    }
};
/************************************************************************** */